export const Patterns = Object.freeze({
  OrganisationNumber: /(^([0-9]{6})-([0-9]{4})$)/i,
  PhoneNumber: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/i,
  IntPhoneNumber: /^(\+\d{1,3})\d{6,14}$/i,
  SenderName: /^[a-zA-Z0-9]{3,11}$/,
  Password: /^.{8,50}$/
  // eslint-disable-next-line no-irregular-whitespace, no-useless-escape
});
